document.addEventListener('DOMContentLoaded', function() {
  var carousels = document.querySelectorAll('.industries__carousel[data-section-id]');

  carousels.forEach(function(carousel) {
    var sectionId = carousel.getAttribute('data-section-id');
    var sectionEl = carousel.closest('.industries-section-' + sectionId);
    if (!sectionEl) return;

    var track = carousel.querySelector('.industries__track');
    var slides = carousel.querySelectorAll('.industries__slide');
    var dragCursor = carousel.querySelector('.industries__drag-cursor');

    if (!track || slides.length === 0) return;

    /* Detect touch device */
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    /* ========================================
       A. DRAG-TO-SCROLL CAROUSEL (desktop only)
       ======================================== */
    var isDragging = false;
    var dragStarted = false;
    var currentTranslate = 0;
    var prevTranslate = 0;

    if (!isTouchDevice) {
      var startX = 0;
      var startTime = 0;

      track.addEventListener('mousedown', onDragStart);
      window.addEventListener('mousemove', onDragMove);
      window.addEventListener('mouseup', onDragEnd);

      track.querySelectorAll('img').forEach(function(img) {
        img.addEventListener('dragstart', function(e) { e.preventDefault(); });
      });

      function onDragStart(e) {
        if (e.type === 'mousedown' && e.button !== 0) return;
        isDragging = true;
        dragStarted = false;
        startX = e.clientX;
        startTime = Date.now();
        track.classList.add('is-dragging');
      }

      function onDragMove(e) {
        if (!isDragging) return;
        var currentX = e.clientX;
        var diff = currentX - startX;

        if (Math.abs(diff) > 5) {
          dragStarted = true;
        }

        var newTranslate = prevTranslate + diff;
        var maxTranslate = 0;
        var minTranslate = -(track.scrollWidth - carousel.offsetWidth);
        currentTranslate = Math.max(minTranslate, Math.min(maxTranslate, newTranslate));
        track.style.transform = 'translateX(' + currentTranslate + 'px)';
      }

      function onDragEnd(e) {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');

        var elapsed = Date.now() - startTime;
        var diff = (e.clientX || 0) - startX;
        if (elapsed < 300 && Math.abs(diff) > 30) {
          var velocity = diff / elapsed;
          var momentum = velocity * 200;
          var newTranslate = currentTranslate + momentum;
          var maxTranslate = 0;
          var minTranslate = -(track.scrollWidth - carousel.offsetWidth);
          currentTranslate = Math.max(minTranslate, Math.min(maxTranslate, newTranslate));
          track.style.transform = 'translateX(' + currentTranslate + 'px)';
        }

        prevTranslate = currentTranslate;
      }

      track.addEventListener('click', function(e) {
        if (dragStarted) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    /* ========================================
       B. CUSTOM DRAG CURSOR
       ======================================== */

    if (!isTouchDevice && dragCursor) {
      carousel.addEventListener('mouseenter', function() {
        dragCursor.classList.add('is-visible');
      });

      carousel.addEventListener('mouseleave', function() {
        dragCursor.classList.remove('is-visible');
      });

      carousel.addEventListener('mousemove', function(e) {
        requestAnimationFrame(function() {
          dragCursor.style.left = e.clientX + 'px';
          dragCursor.style.top = e.clientY + 'px';
        });
      });
    }

    /* ========================================
       C. VIDEO AUTOPLAY
       ======================================== */
    var videos = carousel.querySelectorAll('.industries__lazy-video');

    function setupVideos() {
      videos = carousel.querySelectorAll('.industries__lazy-video');

      videos.forEach(function(video, index) {
        video.muted = true;
        var loadingOverlay = video.parentElement.querySelector('.industries__video-loading');
        var hideSpinner = function() {
          if (loadingOverlay) loadingOverlay.classList.add('hidden');
        };
        video.addEventListener('canplay', hideSpinner, { once: true });
        video.addEventListener('playing', hideSpinner, { once: true });
        video.addEventListener('error', hideSpinner, { once: true });

        setTimeout(function() {
          video.play().catch(function() {});
        }, index * 300);
      });
    }

    setupVideos();

    /* ========================================
       D. RESIZE HANDLER
       ======================================== */
    function clampDesktopTranslate() {
      var minTranslate = -(track.scrollWidth - carousel.offsetWidth);
      if (currentTranslate < minTranslate) {
        currentTranslate = minTranslate;
        prevTranslate = currentTranslate;
        track.style.transform = 'translateX(' + currentTranslate + 'px)';
      }
    }

    function refreshTouchLayout() {
      if (!isTouchDevice) return;

      var currentScrollLeft = track.scrollLeft;

      // iPad Safari can keep the pre-rotation layout until the carousel is repainted.
      track.style.visibility = 'hidden';
      void track.offsetHeight;
      track.style.visibility = '';

      track.scrollLeft = Math.max(0, Math.min(currentScrollLeft, track.scrollWidth - carousel.offsetWidth));

      videos.forEach(function(video) {
        video.play().catch(function() {});
      });
    }

    function rebuildTouchTrack() {
      if (!isTouchDevice) return;

      var maxScrollLeft = Math.max(0, track.scrollWidth - carousel.offsetWidth);
      var scrollRatio = maxScrollLeft > 0 ? track.scrollLeft / maxScrollLeft : 0;
      var clonedSlides = Array.from(track.children).map(function(slide) {
        return slide.cloneNode(true);
      });
      var rebuiltTrack = document.createDocumentFragment();

      clonedSlides.forEach(function(slide) {
        rebuiltTrack.appendChild(slide);
      });

      track.textContent = '';
      track.appendChild(rebuiltTrack);

      slides = carousel.querySelectorAll('.industries__slide');
      setupVideos();

      requestAnimationFrame(function() {
        var nextMaxScrollLeft = Math.max(0, track.scrollWidth - carousel.offsetWidth);
        track.scrollLeft = nextMaxScrollLeft * scrollRatio;
      });
    }

    var resizeTimeout;
    var lastOrientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
    function handleViewportChange() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        clampDesktopTranslate();

        if (isTouchDevice) {
          var nextOrientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
          if (nextOrientation !== lastOrientation) {
            lastOrientation = nextOrientation;
            rebuildTouchTrack();
          }

          requestAnimationFrame(function() {
            requestAnimationFrame(refreshTouchLayout);
          });
        }
      }, 250);
    }

    window.addEventListener('resize', handleViewportChange);
    window.addEventListener('orientationchange', handleViewportChange);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleViewportChange);
    }
  });
});
